<template>
  <div>
    <div class="huge-triangle"></div>
    <div class="block-screen" v-if="loading"><i class="fa fa-spinner fa-spin"></i></div>
    <modal v-if="hasErrors" @close="closeModal" title="Erro ao logar" 
      body="Ocorreu uma falha ao efetuar o login. Tente novamente.">
    </modal>        
    
    <modal v-if="emailError" @close="closeModal" title="Erro ao enviar email" 
      body="Ocorreu uma falha ao tentar enviar o email de recuperação de senha. Verifique se o campo email está correto e tente novamente.">
    </modal> 
    
    <modal v-if="showSuccess" @close="closeModal" title="Email enviado com sucesso." 
      body="Um link para resetar sua senha foi enviado para o seu email. Por favor, verifique as instruções enviadas por email para resetar sua senha." type="info">
    </modal>

    <div class="container login">
      <div class="row">          
        <div class="col-md-7 col-sm-12 block1">
          <img id="logo" src="../assets/images/PTC.png" width="15%" height="auto" style="margin-top: 1.5em;margin-left: 2.4em;margin-bottom: 1.5em;" />
          <h1 style="margin-bottom: 1em;">{{ switchTitle }}</h1>

          <transition name="fade1" appear>
            <form id="form-login" role="form" v-if="!forgotPwd" 
              @submit.prevent="goToRegistration($v.user.$invalid)">           
              <div class="form-group" :class="{ 'has-error': $v.user.registration.$error }">
                <label for="registeredEmail">CPD</label>
                <input type="text" @input="$v.user.registration.$touch()" placeholder="CPD *" v-model="user.registration" autofocus>
                <span class="text-danger" v-if="!$v.user.registration.required && $v.user.registration.$dirty">Utilize seu CPD</span>
              </div>
              <div class="form-group" :class="{ 'has-error': $v.user.password.$error }">
                <div class="input-group">
                  <label for="password">Senha</label>
                  <input v-if="!showPassword" type="password" @input="$v.user.password.$touch()" placeholder="Senha *" v-model="user.password">
                  <input v-if="showPassword" type="text" @input="$v.user.password.$touch()" placeholder="Senha *" v-model="user.password">
                  <span class="input-group-addon" @click="showPassword = !showPassword">
                    <i :class="toggleEyeIcon"></i>
                  </span>
                </div>
                <span class="text-danger" v-if="!$v.user.password.required && $v.user.password.$dirty">A senha é obrigatória.</span>
              </div>
              <div class="login-options">
                <div class="checkbox">
                  <input type="checkbox" id="keep-logged">
                  <label for="keep-logged">Mantenha-me logado</label>                        
                </div>
                <a class="fancy" @click="toggleForgotPwd" href="#">Esqueci a senha</a>                        
              </div>
              <button class="btn btn-block" @click="$v.user.$touch">                            
                ENVIAR
                <span v-if="loading">
                  <i class="fa fa-spinner fa-spin"></i>
                </span>
              </button>
            </form>
          </transition>

          <transition name="fade2">
            <form id="form-forgot" role="form" v-if="forgotPwd">           
              <div class="form-group" :class="{ 'has-error': $v.registeredEmail.$error }">
                <label for="email">Digite seu e-mail cadastrado</label>
                <input type="email" @input="$v.registeredEmail.$touch()" placeholder="E-mail cadastrado *" v-model="registeredEmail" autofocus>
                <span class="text-danger" v-if="!$v.registeredEmail.required && $v.registeredEmail.$dirty">O email é obrigatório.</span>
                <span class="text-danger" v-if="!$v.registeredEmail.email && $v.registeredEmail.$dirty">Digite um email válido.</span>
              </div>
              <button class="btn btn-block" @click.prevent="goToForgotPwd()">
                RECUPERAR A SENHA
                <span v-if="loading">
                  <i class='fa fa-spinner fa-spin '></i>
                </span>
              </button>
              <div class="forgot-password">
                <a class="fancy" @click="toggleForgotPwd" href="#">
                  &larr;&nbsp;Retornar para login
                </a>                     
              </div>
            </form>
          </transition>
          <p class="copyright"><a class="fancy" href="http://www.origamieventos.com.br/" target="_blank">© 2025 Origami Eventos e Turismo</a></p>
        </div>
        <div class="col-md-5 hidden-sm hidden-xs block2">
          <img class="logo-origami" src="../assets/images/logo-origami-black.png"  />
          <img class="airplane" src="../assets/images/airplane.jpg"  />
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import Modal from './shared/Modal.vue';
import { required, email, minLength, maxLength } from 'vuelidate/lib/validators';

export default {
  data: function () {
    return {
      user: {
        registration: '',
        password: ''
      },
      registeredEmail: '',
      showPassword: false,
      loading: false,
      hasErrors: false,
      emailError: false,
      showSuccess: false,
      forgotPwd: false
    }
  },
  components: {
    modal: Modal
  },
  validations: {
    user: {
      registration: { required, minLength: minLength(6), maxLength: maxLength(6) },
      password: { required, minLength: minLength(8), maxLength: maxLength(60) }
    },
    registeredEmail: { required, email }
  },
  mounted: function () {
    if (this.$store.state.user !== null || window.localStorage.getItem('client_origami_user') !== 'null') {
      this.$router.push({name: 'register'});
    }
  },
  methods: {
    goToRegistration: function (validation) {
      if (!validation) {
        this.loading = true;
        
        this.$http.post(`auth/login`, this.user)
          .then(response => {
            this.$store.commit('setUser', response.data.user);
            this.$store.commit('setToken', response.data.token);
            
            if (window.localStorage) {
              window.localStorage.setItem('client_origami_user', JSON.stringify(response.data.user));
              window.localStorage.setItem('client_origami_token', response.data.token);
            }

            this.$http.defaults.headers.Authorization = `Bearer ${window.localStorage.getItem('client_origami_token')}`;

            this.hasErrors = false;
            this.$router.push({name: 'register'}); 
          })
          .catch(e => {
            this.loading = false;
            this.hasErrors = true;
          }); 
      }
    },
    goToForgotPwd: function () {
      if (!this.$v.registeredEmail.$invalid) {
        this.loading = true;
        this.$http.post(`auth/recovery`, {email: this.registeredEmail})
          .then((response) => {
            this.showSuccess = true;
            this.loading = false;
          })
          .catch((response) => {
            this.emailError = true;
            this.loading = false;
          });
      }
    },
    toggleForgotPwd: function () {
      this.forgotPwd = !this.forgotPwd
    },
    closeModal: function () {
      this.hasErrors = false;
      this.emailError = false;
      this.showSuccess = false;
      this.displayUserCompleted = false;
    }
  },
  computed: {
    toggleEyeIcon: function() {
      return {
        "fa fa-eye": this.showPassword,
        "fa fa-eye-slash": !this.showPassword,
      }
    },
    switchTitle: function() {
      return (!this.forgotPwd) ? 'Login' : 'Esqueci a senha'
    }

  }
}
</script>

<style lang="scss" scoped>

@import "../../src/assets/css/variables.scss";


.huge-triangle {
  position: absolute;
  top: 0;
  left: 0;
  width: 0;
  height: 0;
  border-top: 810px solid #fff;
  border-right: 525px solid transparent;

  @include drop-shadow();
}

.login {
  position: relative;
  background-color: #fff;
  margin-top: $baseline * 2; 

  @include box-shadow();

  &:before {
    left: 0;
    position: absolute;
    width: 0;
    height: 0;
    border-top: 108px solid $brand-color;
    border-right: 70px solid transparent;        

  }
}

#logo {
  margin: 3rem 0 0;
}

.block1 {
  padding: 0 50px;

  @media (min-width: 768px) {
    padding: 0 100px;
  }     

  @media (min-width: 992px) {
    padding: 0 70px;
  }      

  @media (min-width: 1200px) {
    padding: 0 100px;
  }    
}

.forgot-password {
  margin-bottom: $baseline;
  text-align: right;
}

.block2 {
  height: 634px;
  padding-right: 0;
  padding-left: 0;
}

.login-options {

  display: block;
  margin-bottom: $baseline;

  @media (min-width: 535px) {
    display: flex; 
    flex-direction: row;
    justify-content: space-between; 
    margin-bottom: 0;
    width: inherit;
  }
}

.logo-origami {
  position: absolute;
  z-index: 1;
  right: 0;
  padding: $baseline $baseline 0 0;
  width: 188px;
  height: auto;
}

.airplane {
  height: inherit;
  object-fit: cover;
  width: 404.16px;
  opacity: .7;
  
  @media (min-width: 1200px) {
    width: 488px;
  }
}

form {
  margin-bottom: 1rem * 2;
}

#form-forgot > .form-group {
  margin: 4.16rem 0;
}


</style> 




// WEBPACK FOOTER //
// src/components/Login.vue